import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import { assetImages } from "constants";
import * as url from "helper/UrlHelper";

const ElectronicPrescriptionsSection = ({ patientObj = null }) => {
  const [rowSelection, setRowSelection] = useState({});
  const [selectedEPrescriptionIds, setSelectedEPrescriptionIds] = useState([]);
  const [selectedEPrescriptionId, setSelectedEPrescriptionId] = useState(null);

  const ePrescriptionData = [
    {
      _id: "1",
      medication: "Lisinopril",
      dosage: "10mg",
      quantity: "30",
      status: "Sent",
      statusColor: "text-success",
      prescriptionId: "EPR-001",
      datePrescribed: "08/10/2024",
      pharmacy: "CVS Pharmacy",
      doctorname: "Dr. John Smith",
      doctorimage: "",
    },
    {
      _id: "2",
      medication: "Metformin",
      dosage: "500mg",
      quantity: "60",
      status: "Pending",
      statusColor: "text-warning",
      prescriptionId: "EPR-002",
      datePrescribed: "08/11/2024",
      pharmacy: "Walgreens",
      doctorname: "Dr. Sarah Johnson",
      doctorimage: "",
    },
  ];

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: "Actions",
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasEPrescription"
            aria-controls="offcanvasEPrescription"
            onClick={() => {
              setSelectedEPrescriptionId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      {
        header: "Medication",
        accessorKey: "medication",
      },
      {
        header: "Prescription ID",
        accessorKey: "prescriptionId",
      },
      {
        header: "Dosage",
        accessorKey: "dosage",
      },
      {
        header: "Quantity",
        accessorKey: "quantity",
      },
      {
        header: "Pharmacy",
        accessorKey: "pharmacy",
      },
      {
        header: "Date Prescribed",
        accessorKey: "datePrescribed",
      },
      {
        header: "Doctor Name",
        accessorKey: "doctorname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.doctorname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.doctorimage === ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.doctorimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.doctorname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Status",
        accessorKey: "status",
        Cell: ({ row }) => (
          <p
            className={`d-flex align-items-center gap-1 ${row.original.statusColor} fw-semibold`}
          >
            <span className="d-block material-symbols-outlined icon-md">
              check_circle
            </span>
            <span className="d-block">{row.original.status}</span>
          </p>
        ),
      },
    ],
    []
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  const reloadList = () => {
    // Reload function placeholder
    console.log("Reloading electronic prescriptions list...");
  };

  const updateBulkHandler = () => {
    // Bulk update handler placeholder
    console.log("Bulk update handler...");
  };

  return (
    <div className="p-4 bg-white h-100 rounded-10 shadow-sm">
      <div className="filter-container mb-4">
        <div className="row align-items-center mb-4">
          <div className="col-lg-4">
            <h3 className="mb-0">Electronic Prescriptions</h3>
          </div>
          <div className="col-lg-8 d-flex align-items-center justify-content-end gap-1 gap-sm-2">
            <Link to="#" className="btn btn-gray">
              <span className="d-block material-symbols-outlined">refresh</span>
            </Link>

            <Link to="#" className="btn btn-gray">
              <span className="d-block material-symbols-outlined">tune</span>
            </Link>
            <Link to="#" className="btn btn-primary">
              Add New
            </Link>
          </div>
        </div>
      </div>
      <div className="table-wrapper">
        <MaterialReactTable
          columns={columns}
          data={ePrescriptionData}
          enableGrouping
          enableRowSelection
          getRowId={(row) => row._id}
          onRowSelectionChange={setRowSelection}
          state={{ rowSelection, columnOrder }}
          initialState={{ rowSelection, columnOrder }}
          defaultColumn={{
            minSize: 20,
            maxSize: 300,
            size: 50,
          }}
          muiTableContainerProps={{
            sx: {
              maxHeight: "60vh",
            },
          }}
          enableStickyHeader
        />
      </div>
    </div>
  );
};

export default ElectronicPrescriptionsSection;
